'use strict';

module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/helpers/parseProtocol.js
// module id = 818
// module chunks = 1